import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ChatbotWithContext } from '@wealthlane/chatbot';
import { toast } from 'react-toastify';

import AuthService from '../../services/authService';
import { axiosInstance } from '../../services/apiInterceptor';
import { selectToken } from '../../auth/authSlice';
import { selectAuthRoutesList } from '../../pages/configuration/routeSlice';
import { selectParticipantId } from '../../pages/configuration/participantSignupSlice';
import { useGetSignUpInformation, useWealthlaneCustomerApi } from '../../hooks';
import ToastComponent from '../toast';
import AnimationWrapper from '../animation/animationWrapper';
import { chatbotHttpUrl, configState, devLogger } from './config';
import { getTenantId } from '../../utils/tenantHelpers';

const ChatbotOverlay: React.FC = () => {
  const navigate = useNavigate();
  const authService = new AuthService();
  const token = useSelector(selectToken);
  const participantId = useSelector(selectParticipantId);
  const userAuthList = useSelector(selectAuthRoutesList);
  const { handleRequest } = useWealthlaneCustomerApi();
  const { data: signUpInfo } = useGetSignUpInformation(handleRequest, token);

  const tenantId = getTenantId();
  const resolveTenantId = (): string => getTenantId();

  if (!signUpInfo || !tenantId || !token) {
    return null;
  }

  const customerName = signUpInfo.firstName
    ? `${signUpInfo.firstName} ${signUpInfo.lastName ?? ''}`
    : userAuthList?.currentUser?.name;

  return (
    <AnimationWrapper>
      <div className='relative'>
        <ChatbotWithContext
          cid='0'
          axiosInstance={axiosInstance}
          config={configState}
          tenantIdAccessor={resolveTenantId}
          langfusePublicKey={process.env.REACT_APP_LANGFUSE_PUBLIC_KEY!}
          langfuseEndpointUrl={process.env.REACT_APP_LANGFUSE_BASE_URL!}
          accessTokenAccessor={() => authService.getToken()}
          customerName={customerName}
          sourceRoleId=''
          companyId=''
          httpUrl={chatbotHttpUrl}
          userIdAccessor={() => String(participantId ?? userAuthList?.currentUser?.id ?? '')}
          wsUrl={process.env.REACT_APP_CHATBOT_WEBSOCKET_API!}
          alertFunctionSuccess={(message: string) => {
            toast.success(<ToastComponent label='Success' message={message} />);
          }}
          alertFunctionError={(message: string) => {
            toast.error(<ToastComponent label='Error' message={message} />);
          }}
          transcribeAudioLink={process.env.REACT_APP_CHATBOT_AUDIO_TRANSCRIBE_URL || ''}
          navigate={navigate}
          allowMention={false}
          logger={devLogger}
        />
      </div>
    </AnimationWrapper>
  );
};

export default ChatbotOverlay;
